import api from '../api'
import * as mutationTypes from './mutation-types'

const NO_REPEAT_TRIGGER_FREQUENCIES = {
  MANUAL: 'manual',
  ONE_OFF: 'one_off',
}

const getters = {
  manualTriggers(_state, getters) {
    return getters.resolvedTriggers.filter(
      (trigger) => trigger.frequency === NO_REPEAT_TRIGGER_FREQUENCIES.MANUAL
    )
  },

  oneOffTriggers(_state, getters) {
    return getters.resolvedTriggers.filter(
      (trigger) => trigger.frequency === NO_REPEAT_TRIGGER_FREQUENCIES.ONE_OFF
    )
  },

  recurringTriggers(_state, getters) {
    return getters.resolvedTriggers.filter(
      (trigger) => !(trigger.frequency in NO_REPEAT_TRIGGER_FREQUENCIES)
    )
  },

  manageTrigger() {
    return Silverfin.isCurrentUserAdmin()
  },

  resolvedTriggers(state, _getters, _rootState, rootGetters) {
    if (rootGetters.isSegmentModified) {
      return []
    }
    return state.triggers
  },

  queryTriggers(_state, getters) {
    return getters.resolvedTriggers.filter(
      (trigger) => trigger.frequency !== NO_REPEAT_TRIGGER_FREQUENCIES.ONE_OFF
    )
  },
}

const mutations = {
  [mutationTypes.SET_EDITED_TRIGGER](state, trigger) {
    state.editedTrigger = { ...trigger }
  },

  [mutationTypes.UNSET_EDITED_TRIGGER](state) {
    state.editedTrigger = null
  },

  [mutationTypes.SET_TRIGGERS](state, triggers) {
    state.triggers = triggers
  },

  [mutationTypes.SET_TRIGGER_RUNNING](state, runningStatus) {
    const newTriggers = state.triggers.map((trigger) => {
      if (trigger.id === runningStatus.id) {
        return {
          ...trigger,
          running: runningStatus.running,
          id: runningStatus.id,
          totalCount: runningStatus.total_count,
          processedIds: runningStatus.processed_ids,
          finished: runningStatus.finished,
        }
      }

      return trigger
    })
    state.triggers = newTriggers
  },

  [mutationTypes.SET_TRIGGER_LOADING](state, value) {
    state.triggerLoading = value
  },
}

const actions = {
  setEditedTrigger({ commit }, trigger) {
    commit(mutationTypes.SET_EDITED_TRIGGER, trigger)
  },

  unsetEditedTrigger({ commit }) {
    commit(mutationTypes.UNSET_EDITED_TRIGGER)
  },

  async fetchTriggers({ commit }, segmentId) {
    if (!Silverfin.isCurrentUserAdmin()) {
      return false
    }

    commit(mutationTypes.SET_TRIGGER_LOADING, true)

    const triggers = await api.fetchTriggers(segmentId)

    commit(mutationTypes.SET_TRIGGERS, triggers)
    commit(mutationTypes.SET_TRIGGER_LOADING, false)
  },

  runTrigger({ commit }, trigger) {
    commit(mutationTypes.SET_TRIGGER_RUNNING, { id: trigger.id, running: true })

    window.$.ajax({
      method: 'POST',
      url: Silverfin.Routes.run_insight_trigger_path(
        Silverfin.currentFirmId,
        trigger.id,
        { segment_id: trigger.segment.id }
      ),
    })
  },

  setTriggerRunning({ commit }, runningStatus) {
    commit(mutationTypes.SET_TRIGGER_RUNNING, runningStatus)
  },
}

export default {
  state() {
    return {
      editedTrigger: null,
      triggers: [],
      triggerLoading: false,
    }
  },
  getters,
  mutations,
  actions,
}
